import React from "react";
import * as S from "./styled";
import { useToggle } from "@/hooks/useToggle";

type tProps = {
  limit: number;
  text: string;
  className?: string;
  Component: (props?: any) => JSX.Element;
};
const CroppedText = ({ limit, Component, text, className }: tProps) => {
  const [show, toggleShow] = useToggle(false);
  if (!text) return null;
  return (
    <Component>
      {show ? text : text.slice(0, limit)}
      {text.length > limit && (
        <S.Button
          className={className}
          onClick={toggleShow}
          title={show ? "Скрыть текст" : "Показать текст"}
        >
          ...
        </S.Button>
      )}
    </Component>
  );
};

export default CroppedText;
